import { render, staticRenderFns } from "./gbControl.vue?vue&type=template&id=8534c676&scoped=true&"
import script from "./gbControl.vue?vue&type=script&lang=js&"
export * from "./gbControl.vue?vue&type=script&lang=js&"
import style0 from "./gbControl.vue?vue&type=style&index=0&id=8534c676&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8534c676",
  null
  
)

export default component.exports